import { createSelector } from 'reselect';
import { RootState } from '../rootReducer';
import { AttributesState } from 'types/attributes/attributes.types';

const selectAttributesState = (state: RootState): AttributesState => state.attributes;

export const selectAttributes = createSelector(
    [selectAttributesState],
    (attributesState) => attributesState.attributes
);

export const selectAttributesLoading = createSelector(
    [selectAttributesState],
    (attributesState) => attributesState.loading
);

export const selectAttributesError = createSelector(
    [selectAttributesState],
    (attributesState) => attributesState.error
);